import { useQuery } from "@tanstack/react-query";
import { getCities } from "../../service/query/auth";

export const useGetCities= (id) => {
  const cities = useQuery({
    queryKey:["CITIES", id],
    queryFn:async()=> getCities({id}),
    enabled: !!id,
    staleTime: 0,
  },

);
  return {data:cities?.data?.data,  ...cities,}
};